<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
<div class="d-grid" style="gap: 0.8rem;grid-template-columns: 1fr 1fr;">
  <div class="wccard p-3 settingHover rounded">
    <p class="f-28 mb-3"><a data-testid="auto-app-old-settings-a-1"><i class="fa-solid fa-puzzle gt"></i></a></p>
    <p class="f-14 font-weight-500 mb-1">ATS Integration</p>
    <p class="mb-0"><a data-testid="auto-app-old-settings-a-2" href="#" class="onhoveraction" [routerLink]='["/new-settings/ats-integrations"]'>View All</a></p>
  </div>
  <div class="wccard p-3 settingHover rounded">
    <p class="f-28 mb-3"><a data-testid="auto-app-old-settings-a-3"><i class="fas fa-envelope gt"></i></a></p>
    <p class="f-14 font-weight-500 mb-1">Email Settings</p>
    <p class="mb-0">
      <a data-testid="auto-app-old-settings-a-4" href="#" class="onhoveraction mr-1" routerLink="/settings/emailtemplate">Email Template</a> |
      <a data-testid="auto-app-old-settings-a-5" href="#" class="onhoveraction ml-1" routerLink="/settings/email-integration">Integration</a>
    </p>
  </div>
  <div class="wccard p-3 settingHover rounded">
    <p class="f-28 mb-3"><a data-testid="auto-app-old-settings-a-6" class="onhoveraction"><i class="fas fa-layer-group gt"></i></a></p>
    <p class="f-14 font-weight-500 mb-1">Company Metadata</p>
    <a data-testid="auto-app-old-settings-a-7" href="#" class="onhoveraction" routerLink="/settings/calllog">Call log</a>
  </div>
  <div class="wccard p-3 settingHover rounded">
    <p class="f-28 mb-3"><a data-testid="auto-app-old-settings-a-8"><i class="fas fa-file-user gt"></i></a></p>
    <p class="f-14 font-weight-500 mb-1">Accounts</p>
    <p class="mb-0"><a data-testid="auto-app-old-settings-a-9" href="#" class="onhoveraction" routerLink="/subscription/usage">Usage</a> </p>
  </div>
</div>
